<template>
  <div class="main-container">
    <div class="inner-container">
            <div class="inner-track-shipment-container">
                <div>
                    <signed-in-user-info :user="user" :userData="userData" />
                    <div class="track-shipment">
                        <div class="create-shipment-container">
                            <div class="create-shipment-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                    <g id="Layer_1-2" data-name="Layer 1">
                                        <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                    </g>
                                </svg>
                            </div>
                            
                            <div class="create-shipment-router-link">
                                <router-link class="router-link" to="/Ship"><p>Create Shipment</p></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="true" class="data-container">
                    <div class="header-track-shipment">
                        <div class="header-track-inner">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                                <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                    <g>
                                    <g>
                                        <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                        <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                        <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                        <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                        <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                        <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                        <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                    </g>
                                    <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                    <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                    <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                    </g>
                                </g>
                                </svg>
                            <p>Daily Deliveries</p>
                        </div>
                    </div>
                    <delivery-data-line-chart :accountNo="userData.accountNo" :userData="userData"/>
                </div>
                <div class="track-shipment weather">
                    <weather-widget :userData="userData"/>
                    <div class="track-shipment">
                        <div class="header-track-shipment">
                            <div class="header-track-inner">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 128.83">
                                        <g id="Layer_2-2" data-name="Layer 2">
                                            <g id="_Ñëîé_1" data-name=" Ñëîé 1">
                                            <g>
                                                <path d="M87,45.5c0,33.5-41.5,77.5-41.5,77.5,0,0-41.5-44-41.5-77.5C4,22.58,22.58,4,45.5,4s41.5,18.58,41.5,41.5Z" style="fill: none; stroke: #000; stroke-miterlimit: 10; stroke-width: 8px;"/>
                                                <circle cx="45" cy="45" r="19" style="fill: none; stroke: #000; stroke-miterlimit: 10; stroke-width: 8px;"/>
                                            </g>
                                            </g>
                                        </g>
                                    </svg>
                                <p>Track Shipment</p>
                            </div>
                        </div>
                        <div class="shipment-id-container">
                            <div class="input-shipment-id">
                                <form @submit.prevent="trackShipment()">
                                    <input v-model="trackShipmentID" type="text">
                                </form>
                                <button @click="trackShipment()">Track</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div class="data-container-main">
            <div class="data-container">
                <div class="header-track-shipment">
                    <div class="header-track-inner">
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                </g>
                            </svg>
                        <p>Your Shipments</p>
                    </div>
                </div>
                <doughnut-chart :countDateRangeDelivered="countDateRangeDelivered" :refreshAfterVoidBool="refreshAfterVoidBool" :userData="userData" @selectedShipmentType="selectedShipmentType($event)" @selectedBetweenDates="selectedBetweenDates($event)"/>
            </div>
            <div class="table-container">
                <div class="header-track-shipment">
                    <div class="header-track-inner">
                            <svg v-show="selectedShipment == 'In Transit'" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                            <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                <g>
                                <g>
                                    <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                    <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                    <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                    <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                    <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                    <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                    <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                </g>
                                <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                </g>
                            </g>
                            </svg>
                            <svg v-show="selectedShipment == 'Delivered'" version="1.1" id="Layer_2_00000011015521083262897090000013693107950429558190_"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.6 219.7"
                                style="enable-background:new 0 0 320.6 219.7;" xml:space="preserve">
                            <g id="_Ñëîé_1">
                                <g>
                                    <g>
                                        <polyline class="st0" points="59.6,21 93.4,54.7 21,127.6 5,111.7 			"/>
                                        <path class="st0" d="M101.7,187l1.4,1.2l4.7,4.7c4.6,4.6,5.4,12,1.3,17c-4.7,5.8-13.2,6.1-18.4,1l-22.1-21.7
                                            c-5-5-9.4-10.6-13-16.6c-5-8.4-8.4-17.7-10.2-27.3L43.1,132l-13.3-13.2"/>
                                        <path class="st0" d="M106.1,191.2l20,19.9c4.9,4.8,12.7,4.8,17.5-0.1c4.8-4.9,4.8-12.7-0.1-17.5l-1-1l-4.4-4.3l-2.5-2.5"/>
                                        <path class="st0" d="M144.7,194.8l14,13.9l-0.7-0.7l1.9,1.9c4.9,4.8,12.7,4.8,17.6-0.1c2.7-2.7,3.8-6.3,3.5-9.8
                                            c-0.2-2.8-1.4-5.6-3.6-7.8l-9.1-8.7"/>
                                        <path class="st0" d="M85.1,63.1l15.1,14.9l11.4-3.4c12.2-3.7,25.5-1.7,36.1,5.3l51,33.9c2.1,1.4,3,3.7,2.8,6c-0.1,1-0.4,2-1,2.9
                                            c-5.9,9-18.2,11.3-26.9,5L159,117.4c-1.2-0.8-2.5-1.3-3.8-1.4c-2.4-0.2-4.8,0.7-6.5,2.5c-2.8,3.1-2.7,7.8,0.3,10.8l62,61.6
                                            c5.2,5.2,4.9,13.8-1,18.6c-5,3.9-12.2,3.2-16.8-1.3l-14.5-14.3"/>
                                    </g>
                                    <g>
                                        <polyline class="st0" points="237.1,206.3 315.6,206.3 315.6,5 115.9,5 115.9,49.6 			"/>
                                        <g>
                                            <line class="st0" x1="258.2" y1="177.4" x2="253.3" y2="177.4"/>
                                            <line class="st0" x1="285.9" y1="177.4" x2="281" y2="177.4"/>
                                        </g>
                                    </g>
                                    <polyline class="st0" points="242.2,5 242.2,55.2 213.6,38.6 185,55.2 185,5 		"/>
                                </g>
                            </g>
                            </svg>
                            <svg v-show="selectedShipment == 'Current'" version="1.1" id="Layer_2_00000017498551833638599530000000546862870078238139_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 244 164" xml:space="preserve" data-v-24f3d49d=""><g id="_Ñëîé_1" data-v-24f3d49d=""><g data-v-24f3d49d=""><g data-v-24f3d49d=""><path class="st0" d="M4,110v16c0,5.5,4.5,10,10,10h30" data-v-24f3d49d=""></path><path class="st0" d="M92,136h50c5.5,0,10-4.5,10-10V14c0-5.5-4.5-10-10-10H23" data-v-24f3d49d=""></path><path class="st0" d="M27,4H14C8.5,4,4,8.5,4,14v100" data-v-24f3d49d=""></path><circle class="st0" cx="68" cy="136" r="24" data-v-24f3d49d=""></circle><circle class="st0" cx="196" cy="136" r="24" data-v-24f3d49d=""></circle><line class="st0" x1="128" y1="136" x2="172" y2="136" data-v-24f3d49d=""></line><path class="st0" d="M220,136h10c5.5,0,10-4.5,10-10V87.9c0-2.5-0.9-4.9-2.6-6.8L199,39.2c-1.9-2.1-4.6-3.2-7.4-3.2H152" data-v-24f3d49d=""></path><path class="st0" d="M240,84h-50c-5.5,0-10-4.5-10-10V48" data-v-24f3d49d=""></path></g></g></g><image width="507" height="492" xlink:href="data:image/png;base64,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" transform="matrix(9.068223e-02 0 0 9.068223e-02 10.352 11.3701)" data-v-24f3d49d="" style="overflow: visible;"></image></svg>
                        <p>{{selectedShipment}} Shipments</p>
                    </div>
                </div>
                <shipment-table @dateRangeDeliveredCount="dateRangeDeliveredCount($event)" @refreshAfterVoid="refreshAfterVoid($event)" :cognitoUser="user" :selectedShipment="selectedShipment" :selectedDates="selectedDates" :jwtToken="jwtToken" :userData="userData"/>
            </div>
        </div>
         <div class="data-container-main">
            <div v-if="false" class="data-container">
                <div class="header-track-shipment">
                    <div class="header-track-inner">
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                            <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                <g>
                                <g>
                                    <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                    <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                    <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                    <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                    <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                    <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                    <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                </g>
                                <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                </g>
                            </g>
                            </svg>
                        <p>Polar Area Chart</p>
                    </div>
                </div>
                <polar-area-chart :refreshAfterVoidBool="refreshAfterVoidBool" :userData="userData" @selectedShipmentType="selectedShipmentType($event)" @selectedBetweenDates="selectedBetweenDates($event)"/>
            </div>
            <div v-if="false" class="data-container">
                <div class="header-track-shipment">
                    <div class="header-track-inner">
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                            <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                <g>
                                <g>
                                    <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                    <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                    <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                    <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                    <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                    <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                    <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                </g>
                                <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                </g>
                            </g>
                            </svg>
                        <p>Bar Chart</p>
                    </div>
                </div>
                <bar-chart :refreshAfterVoidBool="refreshAfterVoidBool" :userData="userData" @selectedShipmentType="selectedShipmentType($event)" @selectedBetweenDates="selectedBetweenDates($event)"/>
            </div>
        </div>
    </div>
  </div>
  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
  <shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :userData="userData" :cognitoUser="user" :trackShipmentID="trackShipmentID" :jwtToken="jwtToken"/>
</template>

<script>
import DoughnutChart from './DoughnutChart.vue'
import ShipmentTable from './ShipmentTable.vue'
import WeatherWidget from './WeatherWidget.vue'
import ShipmentInfo from './ShipmentInfo.vue'
import BarChart from './BarChart.vue'
import DeliveryDataLineChart from './DataVizualization/DeliveryDataLineChart.vue'
import PolarAreaChart from './PolarAreaChart.vue'
import SignedInUserInfo from '../ShipmentDashboard/UserDashboard/SignedInUserInfo.vue'
import {Auth, API} from 'aws-amplify'
import AlertUser from '../../components/Popups/AlertUser.vue';

export default {
    components:{
        DoughnutChart,
        ShipmentTable,
        WeatherWidget,
        BarChart,
        PolarAreaChart,
        ShipmentInfo,
        AlertUser,
        SignedInUserInfo,
        DeliveryDataLineChart
    },
    data(){
        return{
            selectedShipment: 'In Transit',
            user: {},
            userData: {},
            trackShipmentID: null,
            toggleTrackShipment: false,
            selectedDates: null,
            refreshAfterVoidBool: false,
            loadingUser: false,
            jwtToken: '',
            toggleAlertBox: false,
            alertMessage: "",
            countDateRangeDelivered: null
        }
    },
    methods:{
        dateRangeDeliveredCount(event){
            this.countDateRangeDelivered = event;
        },
        async trackShipment(){
            await Auth.currentAuthenticatedUser().then(user => {
                this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            }).catch(error => {
                if(error){
                    this.$router.push('Login');
                    Auth.signOut({global: false})
                }
            });
            this.toggleTrackShipment = true;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
        },
        selectedShipmentType(event){
            this.selectedShipment = event;
        },
        selectedBetweenDates(event){
            this.selectedDates = event;
        },
        refreshAfterVoid(event){
            this.refreshAfterVoidBool = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: 
                    `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
                await this.GetAccountGraphQL();
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async GetAccountGraphQL(){
            this.loadingUser = true;
            try {
                let accountReturnData = await API.graphql({
                    query: 
                    `query GetAccount($accountNo: String!){
                        getAccount(accountNo: $accountNo){
                            billable
                        }
                    }`,
                    variables: {
                            accountNo: this.userData.accountNo
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                let accountData = accountReturnData.data.getAccount;
                console.log(accountData)
                // if(accountData.billable == false){
                //     this.$router.push('/AccountAddPaymentForm')
                // }
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get account information"
            }finally{
                this.loadingUser = false;
            }
        }
    },
    mounted(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
}
</script>

<style scoped>
.st0 {
	fill: none;
	stroke: #000;
	stroke-width: 10;
	stroke-linecap: round;
	stroke-linejoin: round
}

.cls-1 {
	fill: none;
	stroke: #3f3f3f;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-width: 10px
}

.cls-2 {
	fill: none;
	stroke: #000;
	stroke-miterlimit: 10;
	stroke-width: 8px
}

html {
	background-color: #f3f3f3
}

.main-container {
	margin-top: 20px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center
}

.inner-container {
	width: 70%;
	background-color: #fff;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	border-radius: 25px
}

.data-container-main {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly
}

.inner-track-shipment-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center
}

.table-container {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	height: fit-content;
	flex-basis: 50%;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column
}

.data-container {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	flex-basis: 25%;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	height: fit-content
}

.track-shipment {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	flex-basis: 25%;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column
}

.weather {
	padding: 0;
	width: fit-content;
	background-color: transparent;
	box-shadow: none
}

.header-track-shipment p {
	font-size: 18px;
	margin: 0;
	margin-left: 10px
}

.header-track-shipment {
	width: 100%;
	margin-bottom: 5px
}

.header-track-inner {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: fit-content;
	background-color: #e2e2e2;
	padding: 5px 15px;
	border-radius: 999px
}

.svg-container {
	height: auto;
	display: flex;
	justify-content: center;
	align-items: center
}

.header-track-inner svg {
	height: 18px;
	margin: 0
}

.create-shipment-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 40px
}

.create-shipment-container svg {
	height: 20px
}

.create-shipment-svg {
	background-color: #32ccfe;
	border: 1px solid #32ccfe;
	border-radius: 15px 0 0 15px;
	display: flex;
	align-items: center;
	height: 30px;
	padding: 5px 10px
}

.router-link {
	border: 1px solid #d9d9d9;
	border-radius: 0 15px 15px 0;
	height: 30px;
	padding: 5px;
	display: flex;
	align-items: center;
	transition-duration: .5s
}

.router-link:hover {
	background-color: #eee;
	transition-duration: .25s;
	cursor: pointer
}

.router-link {
	text-decoration: none;
	font-size: 20px
}

.router-link p {
	margin: 0;
	color: #000
}

.shipment-id-container {
	width: 100%;
	display: flex;
	justify-content: flex-start
}

.input-shipment-id {
	display: flex;
	justify-content: flex-start;
	flex-direction: row
}

.input-shipment-id input {
	border: 1px solid #e2e2e2;
	border-right: none;
	padding: 5px;
	border-radius: 25px 0 0 25px;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

.input-shipment-id button {
	cursor: pointer;
	border: 1px solid #e2e2e2;
	background-color: #32ccfe;
	color: #fff;
	padding: 5px;
	border-radius: 0 10px 10px 0;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	transition-duration: .5s
}

.input-shipment-id button:hover {
	background-color: #2baeda;
	transition-duration: .5s
}

.user-info {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	text-align: left
}

.user-info p {
	margin: 0
}

@media only screen and (max-width:1300px) {
	.inner-container {
		width: 85%
	}
}

@media only screen and (max-width:1000px) {

	.data-container-main,
	.inner-track-shipment-container {
		flex-wrap: wrap
	}

	.track-shipment {
		flex-basis: 40%
	}

	.data-container {
		flex-basis: 40%
	}

	.table-container {
		flex-basis: 80%
	}
}

@media only screen and (max-width:600px) {
	.inner-container {
		width: 95%
	}

	.data-container {
		flex-basis: 80%
	}

	.table-container {
		flex-basis: 90%;
		font-size: 10px
	}

	.track-shipment {
		flex-basis: 80%
	}
}
</style>